// Whole product card clickable → opens the product page (all devices).
// Title/image already are real links; this extends clicks to the rest of the
// card (price area, gaps, whitespace) WITHOUT swallowing the card's own
// interactive elements (add-to-cart, quick-shop, reviews, vendor link, etc.).
(function () {
  // Elements inside a card that must keep their own behaviour on click.
  // NOTE: product labels/badges (SALE, SOLD OUT, custom, flair-badges) are
  // intentionally NOT listed here — tapping a label should open the product.
  // Any real <a> inside a badge still works because `a` stays in the list.
  const INTERACTIVE = 'a, button, input, select, textarea, label, summary, ' +
    '[data-quick-add], .product-login, .quick-shop-modal-trigger, ' +
    '.product-list-item-inventory, .product-list-item-reviews, ' +
    '.jdgm-widget, .jdgm-prev-badge, .jdgm-star';

  function navigate(url, event) {
    // Preserve "open in new tab" expectations (cmd/ctrl/middle click).
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.button === 1) {
      window.open(url, '_blank');
    } else {
      window.location.href = url;
    }
  }

  function handle(event) {
    // Ignore secondary (right) clicks.
    if (event.button !== undefined && event.button !== 0 && event.button !== 1) return;

    const card = event.target.closest('.product-list-item[data-card-link]');
    if (!card) return;

    // Let genuine interactive elements handle their own click.
    if (event.target.closest(INTERACTIVE)) return;

    // Don't hijack text selection.
    const selection = window.getSelection && window.getSelection();
    if (selection && selection.toString().length > 0) return;

    const url = card.getAttribute('data-card-link');
    if (!url) return;

    event.preventDefault();
    navigate(url, event);
  }

  document.addEventListener('click', handle);
  // Support middle-click (auxclick) to open in a new tab.
  document.addEventListener('auxclick', function (event) {
    if (event.button === 1) handle(event);
  });
})();
